import React from 'react';
import { ServiceHours } from '../../../../models/UnitInfo';
import { dayOfWeekMap, WorkHour } from '../WorkHour';

type WorkHoursProps = {
  service_hours: ServiceHours;
};

const LocationServiceHours: React.FC<WorkHoursProps> = ({ service_hours = [] }) => {
  const workHours = Object.entries(service_hours);
  const workHoursSorted = workHours.sort(([weekDay], [nextWeekDay]) => {
    const index1 = Object.keys(dayOfWeekMap).findIndex(day => day === weekDay);
    const index2 = Object.keys(dayOfWeekMap).findIndex(day => day === nextWeekDay);
    if (index1 > index2) return 1;
    return -1;
  });

  return (
    <>
      {workHoursSorted.map(([weekDay, period], index) => (
        <WorkHour key={index} period={period} weekDay={weekDay} />
      ))}
    </>
  );
};

export default LocationServiceHours;
